<!--
 * @Author: vince
 * @Date: 2021-09-05 16:03:44
 * @LastEditors: vince 273187189@qq.com
 * @LastEditTime: 2022-01-18 14:54:13
 * @Description: 
-->
<template>
  <el-container>
    <el-header class="head">
      <el-menu
        :default-active="activeIndex"
        class="reportTab"
        mode="horizontal"
        @select="onTabClick"
      >
        <el-menu-item index="first">教师信息</el-menu-item>
        <el-menu-item index="second">教师分析</el-menu-item>
      </el-menu>
    </el-header>
    <el-main>
      <el-tabs class="notab" v-model="activeIndex">
        <el-tab-pane name="first">
          <div class="pa-md bg-white">
            <el-form class="full-width mb-sm" :model="teacherInfoForm">
              <div class="filter-bar pa-none">
                <el-form-item class="mb-none" label="职称">
                  <dic-selector
                    checkAll
                    dicType="academic_titles"
                    v-model="teacherInfoForm.academicTitles"
                    @change="() => refreshTeachrInfo()"
                  ></dic-selector>
                </el-form-item>
                <el-form-item class="mb-none" label="校内职务">
                  <dic-selector
                    checkAll
                    dicType="teacherDuty"
                    v-model="teacherInfoForm.userDuty"
                    @change="() => refreshTeachrInfo()"
                  ></dic-selector>
                </el-form-item>
                <el-form-item class="mb-none" label="校区">
                  <school-selector
                    checkAll
                    v-model="teacherInfoForm.school"
                    @change="() => refreshTeachrInfo()"
                  ></school-selector>
                </el-form-item>
                <el-form-item class="mb-none">
                  <el-input
                    size="small"
                    v-model="teacherInfoForm.keyword"
                    @input="() => refreshTeachrInfo()"
                    clearable
                    placeholder="搜索教师姓名"
                  >
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                  </el-input>
                </el-form-item>
                <div class="space"></div>
              </div>
            </el-form>
            <el-table
              :data="teacherStatisticsList"
              header-cell-class-name="tbh"
              style="width: 100%"
            >
              <el-table-column type="expand">
                <template slot-scope="props">
                  <!-- <span> {{props.row.userName}}</span> -->
                  <el-table
                    :data="[props.row]"
                    header-cell-class-name="tbh"
                    style="width: 100%"
                  >
                    <el-table-column label="学科" align="center">
                      <template slot-scope="scope">
                        {{
                          scope.row.schoolDiscipline
                            ? scope.row.schoolDiscipline
                            : ""
                        }}
                      </template>
                    </el-table-column>
                    <el-table-column label="年级" align="center">
                      <template slot-scope="scope">
                        {{ scope.row.gradeName ? scope.row.gradeName : "" }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="academicTitlesDesc"
                      label="职称"
                      align="center"
                    ></el-table-column>
                    <el-table-column
                      label="校内职务"
                      align="center"
                      prop="schoolDutyDesc"
                    >
                    </el-table-column>
                    <el-table-column
                      label="学历"
                      align="center"
                      prop="educationDesc"
                    >
                    </el-table-column>
                    <el-table-column label="学位" align="center">
                      <template slot-scope="scope">
                        {{
                          scope.row.remarkInfo.stuLevel
                            ? scope.row.remarkInfo.stuLevel.dicName
                            : ""
                        }}
                      </template>
                    </el-table-column>
                    <el-table-column label="普通话等级" align="center">
                      <template slot-scope="scope">
                        {{
                          scope.row.remarkInfo.speakLevel
                            ? scope.row.remarkInfo.speakLevel.dicName
                            : ""
                        }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="graduateSchool"
                      label="毕业学校"
                      align="center"
                    ></el-table-column>
                  </el-table>
                </template>
              </el-table-column>
              <el-table-column prop="teacherNum" label="师训号" align="center">
              </el-table-column>
              <el-table-column
                prop="userName"
                label="姓名"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="mobile"
                label="手机号"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="birthday"
                label="出生年月"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="schoolName"
                label="校区"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="userSex"
                label="性别"
                align="center"
              ></el-table-column>

              <pagination
                v-if="teacherStatisticsList.length > 0"
                class="mb-md mr-md"
                slot="append"
                :pageObj="teacherInfoForm"
                @handleSizeChange="firstHandleSizeChange"
                @handleCurrentChange="firstTeacherPageChange"
              ></pagination>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane name="second">
          <div class="bg-white pa-md">
            <el-form class="full-width mb-2px" :model="teacherAnalysisForm">
              <div class="filter-bar pa-none">
                <el-form-item class="mb-none" label="学年">
                  <school-year-selector
                    checkAll
                    v-model="teacherAnalysisForm.schoolYear"
                    @change="refresh"
                  ></school-year-selector>
                </el-form-item>
                <el-form-item class="mb-none" label="学期">
                  <school-term-selector
                    checkAll
                    v-model="teacherAnalysisForm.schoolTerm"
                    @change="refresh"
                  ></school-term-selector>
                </el-form-item>
                <el-form-item class="mb-none" label="校区">
                  <school-selector
                    checkAll
                    v-model="teacherAnalysisForm.school"
                    @change="refresh"
                  ></school-selector>
                </el-form-item>
                <div class="space"></div>
              </div>
            </el-form>
            <el-row>
              <el-col :span="12">
                <div class="chart-box">
                  <div class="box">
                    <echarts :option="option1"></echarts>
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="chart-box">
                  <div class="box">
                    <echarts :option="option2"></echarts>
                  </div>
                </div>
              </el-col>
            </el-row>
            <div class="chart-box" style="padding-bottom: 40%">
              <div class="box">
                <div class="awardTit">教师获奖统计</div>
                <echarts
                  v-if="teacherAwardInfoList.length > 0"
                  :option="option3"
                ></echarts>
                <div v-else class="no-more">暂无数据...</div>
              </div>
            </div>
            <div class="filter-row my-filter pa-md">
              <span class="score"
                >总积分:
                {{
                  teacherScoreList.length > 0
                    ? teacherScoreList[0].scoreCount
                    : 0
                }}分</span
              >
              <el-input
                size="small"
                @change="teacherScoreInfo(1)"
                v-model="scoreSearch.keyword"
                clearable
                placeholder="搜索教师姓名"
                style="width: 220px"
              >
                <template v-slot:append>
                  <span @click="teacherScoreInfo(1)">搜索</span>
                </template>
              </el-input>
              <!-- <div style="margin: 0px 30px">
                <span class="se-nake">四新团队：</span>
                <el-select
                  @change="teacherScoreInfo(1)"
                  size="small"
                  v-model="scoreSearch.team"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in sxOptions"
                    :key="item.value"
                    :label="item.lable"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div> -->
              <div style="margin-right: 30px">
                <!-- <span class="se-nake">学院：</span>
                <dicSelector
                  v-model="scoreSearch.collegeCode"
                  size="small"
                  checkAll
                  dicType="affiliated-college"
                  @change="teacherScoreInfo(1)"
                ></dicSelector> -->
                <!-- <el-select
                  @change="teacherScoreInfo(1)"
                  size="small"
                  v-model="scoreSearch.schoolCodes"
                  multiple
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in schoolList"
                    :key="item.schoolCode"
                    :label="item.schoolName"
                    :value="item.schoolCode"
                  ></el-option>
                </el-select> -->
              </div>
              <el-button type="primary" size="small" @click="toExport"
                >导出</el-button
              >
            </div>
            <el-table
              :data="teacherScoreList"
              header-cell-class-name="tbh"
              style="width: 100%"
            >
              <el-table-column
                prop="teacherName"
                label="教师"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="schoolName"
                label="校区"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="teacherNum"
                label="师训号"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="scoreNum"
                label="积分"
                align="center"
              ></el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-popover placement="right" width="500" trigger="click">
                    <el-table
                      :data="teacherDetailsScore"
                      max-height="500"
                      v-loading="detailsLoading"
                    >
                      <el-table-column
                        prop="actTitle"
                        label="活动名称"
                      ></el-table-column>
                      <el-table-column
                        prop="remark"
                        label="获得积分"
                      ></el-table-column>
                      <el-table-column
                        prop="createTime"
                        label="时间"
                      ></el-table-column>
                      <el-table-column
                        prop="score"
                        label="积分"
                      ></el-table-column>
                    </el-table>
                    <el-button
                      slot="reference"
                      @click="showDetailsScore(scope.row.teacherId)"
                      type="text"
                      size="small"
                      >查看</el-button
                    >
                  </el-popover>
                </template>
              </el-table-column>
              <pagination
                v-if="teacherScoreList.length > 0"
                class="mb-md mr-md"
                slot="append"
                :pageObj="scoreSearch"
                @handleSizeChange="handleSizeChange"
                @handleCurrentChange="teacherScorePageChange"
              ></pagination>
            </el-table>
            <!-- 导出的表格 -->
            <el-table
              v-show="false"
              id="battery"
              :data="teacherScoreList"
              header-cell-class-name="tbh"
              style="width: 100%"
            >
              <el-table-column
                prop="teacherName"
                label="教师"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="schoolName"
                label="校区"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="teacherNum"
                label="师训号"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="scoreNum"
                label="积分"
                align="center"
              ></el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-main>
  </el-container>
</template>

<script>
import DicSelector from "../../components/school/dicSelector.vue";
import pagination from "../../components/Pagination.vue";
import schoolYearSelector from "../../components/school/schoolYearSelector.vue";
import schoolTermSelector from "../../components/school/schoolTermSelector.vue";
import SchoolSelector from "../../components/school/schoolSelector.vue";
import { postData, postJson, getData } from "../../http/fetch.js";
import Echarts from "../../components/echarts.vue";
import { mapGetters, mapState } from "vuex";
import FileSaver from "file-saver";
import XLSX from "xlsx";
export default {
  name: "teacherReport",
  components: {
    schoolYearSelector,
    schoolTermSelector,
    SchoolSelector,
    Echarts,
    pagination,
    DicSelector,
  },
  data() {
    return {
      collegeCode: null,
      rankList: "",
      activeIndex: "first", //second
      detailsLoading: false,
      teacherDetailsScore: [],
      tableData: [],
      teacherAwardInfoList: [],
      teacherAcademicTitlesList: [],
      resourceStatisticsList: [],
      teacherStatisticsList: [],
      teacherGenerationList: [],
      teacherScoreList: [],
      teacherInfoForm: {
        school: null,
        academicTitles: null,
        userDuty: null,
        schoolTemp: null,
        keyword: null,
        current: 1,
        size: 10,
        total: 0,
      },
      teacherAnalysisForm: {
        keyword: null,
        schoolYear: null,
        schoolTerm: null,
        school: null,
        schoolCode: null,
      },
      scoreSearch: {
        current: 1,
        size: 10,
        total: 0,
        sizeList: [5, 10, 15, 20],
        team: 0, //四新
        collegeCode: null, //学院
        keyword: null,
      },
      scoreCount: 0,
      sxOptions: [
        { lable: "全部", value: 0 },
        { lable: "新芽", value: 1 },
        { lable: "新苗", value: 2 },
        { lable: "新星", value: 3 },
        { lable: "新家", value: 4 },
      ],
      moduleDicOptions: [],
      // allScore:0,
    };
  },
  filters: {
    arrToStringFilters: function (arr) {
      if (arr && arr.length > 0) {
        return arr.map((i) => i.dicName).toString();
      } else {
        return "";
      }
    },
  },
  computed: {
    ...mapState(["userInfo"]),
    ...mapGetters(["schoolCodes", "schoolList"]),
    option1() {
      let data = this.teacherAcademicTitlesList;
      let total = 0;
      if (
        this.teacherAcademicTitlesList &&
        this.teacherAcademicTitlesList.length > 0
      ) {
        data.forEach((f) => {
          total += f.value;
        });
      }

      return {
        tooltip: {
          trigger: "item",
        },
        title: {
          text: "教师职称统计",
          left: "center",
          top: "5%",
          textStyle: {
            fontSize: 20,
            fontFamily: "pfmd",
            fontWeight: 500,
            color: "#333333",
          },
        },
        legend: {
          icon: "circle",
          top: "middle",
          right: "10%",
          orient: "vertical",
          textStyle: {
            fontFamily: "pfrgl",
          },
          formatter:
            this.teacherAcademicTitlesList &&
            this.teacherAcademicTitlesList.length
              ? function (name) {
                  return (
                    name +
                    " | " +
                    (
                      (data.find((f) => f.name == name).value / total) *
                      100
                    ).toFixed(2) +
                    "%"
                  );
                }
              : null,
        },
        series: [
          {
            name: "教师职称统计",
            type: "pie",
            center: ["35%", "50%"],
            radius: ["0%", "55%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 0,
            },
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: "40",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: data,
          },
        ],
      };
    },
    option2() {
      let data = this.teacherGenerationList;
      let total = 0;
      if (this.teacherGenerationList && this.teacherGenerationList.length > 0) {
        data.forEach((f) => {
          total += f.value;
        });
      }

      return {
        tooltip: {
          trigger: "item",
        },
        title: {
          text: "教师年龄段统计",
          left: "center",
          top: "5%",
          textStyle: {
            fontSize: 20,
            fontFamily: "pfmd",
            fontWeight: 500,
            color: "#333333",
          },
        },
        legend: {
          icon: "circle",
          top: "middle",
          right: "10%",
          orient: "vertical",
          textStyle: {
            fontFamily: "pfrgl",
          },
          formatter:
            this.teacherAcademicTitlesList &&
            this.teacherAcademicTitlesList.length &&
            total
              ? function (name) {
                  return (
                    name +
                    " | " +
                    (
                      (data.find((f) => f.name == name).value / total) *
                      100
                    ).toFixed(2) +
                    "%"
                  );
                }
              : null,
        },
        series: [
          {
            name: "教师年龄段统计",
            type: "pie",
            center: ["35%", "50%"],
            radius: ["0%", "55%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 0,
            },
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: "40",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: data,
          },
        ],
      };
    },
    option3() {
      let data = [];
      if (this.teacherAwardInfoList && this.teacherAwardInfoList.length) {
        data = this.teacherAwardInfoList.map((m) => {
          return [m.awardCount, m.ranksDesc];
        });
      }
      return {
        // title: {
        // 	text: "教师获奖统计",
        // 	left: "center",
        // 	top: "0%",
        // 	textStyle: {
        // 		fontSize: 20,
        // 		fontFamily: "pfmd",
        // 		fontWeight: 500,
        // 		color: "#333333"
        // 	}
        // },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "10%",
          containLabel: true,
        },
        color: ["#1890FF"],
        yAxis: [
          {
            type: "category",
            axisLine: {
              color: "#D9D9D9",
            },
            axisLabel: {
              fontFamily: "pfrgl",
            },
            axisTick: {
              alignWithLabel: true,
              color: "#D9D9D9",
            },
          },
        ],
        xAxis: [
          {
            type: "value",
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            splitArea: false,
          },
        ],
        series: [
          {
            label: {
              show: true,
              position: "right",
            },
            name: "教师获奖",
            type: "bar",
            barWidth: "20%",
            data: data,
          },
        ],
      };
    },
  },
  watch: {},
  created() {
    this.getDic("level").then((res) => {
      this.rankList = res;
    });
    this.getDic("module").then((res) => {
      this.moduleDicOptions = res;
    });
    //this.teacherScoreInfo();
  },
  mounted() {
    this.refreshTeachrInfo();
  },
  methods: {
    toExport() {
      this.loading = true;
      this.$axios
        .post(
          "/teacherDevelopment/exportTeacherScoreInfo",
          this.$qs.stringify({
            keyword: this.scoreSearch.keyword,
            pageNum: this.scoreSearch.current,
            pageSize: this.scoreSearch.size,
            schoolCodes: this.teacherAnalysisForm.school
              ? [this.teacherAnalysisForm.school.schoolCode]
              : this.schoolCodes,
            collegeCode:
              this.scoreSearch.collegeCode &&
              this.scoreSearch.collegeCode.dicCode
                ? [this.scoreSearch.collegeCode.dicCode]
                : null,
            team: this.scoreSearch.team,
            schoolTerm: this.teacherAnalysisForm.schoolTerm,
            schoolYear: this.teacherAnalysisForm.schoolYear,
          }),
          {
            responseType: "blob",
          }
        )
        .then((res) => {
          this.loading = false;
          let fileName = window.decodeURI(
            res.headers["content-disposition"].split("=")[1]
          );
          const url = URL.createObjectURL(res.data);
          const a = document.createElement("a");
          a.href = url;
          a.download = fileName; // 设置下载的文件名
          a.click();
          URL.revokeObjectURL(url);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async showDetailsScore(userId) {
      this.detailsLoading = true;
      let { records, total } = await postJson("/planning/getMyScoreList", {
        // schoolTerm: "",
        // schoolYear: "",
        module: this.activeCode,
        userId: userId,
        pageNum: 1,
        pageSize: -1,
      });
      this.teacherDetailsScore = records;

      if (this.teacherDetailsScore && this.teacherDetailsScore.length > 0) {
        this.teacherDetailsScore.forEach((i) => {
          if (this.moduleDicOptions.find((m) => m.dicCode === i.module)) {
            i.moduleName = this.moduleDicOptions.find(
              (m) => m.dicCode === i.module
            ).dicName;
          }
        });
      }

      this.detailsLoading = false;
    },
    // getAllScore(){
    //   postData("/planning/getScoreSum",{
    //     userId:this.userInfo.userId
    //   }).then(data=>{
    //     this.allScore=data
    //   })
    // },
    // async showDetailsScore(userId) {
    //   this.detailsLoading = true;
    //   let { teacherScoreDTOS } = await postJson("/planning/getEffectiveness", {
    //     schoolTerm: "",
    //     schoolYear: "",
    //     module: "",
    //     userId: userId,
    //   });
    //   this.teacherDetailsScore = teacherScoreDTOS;
    //   if (this.teacherDetailsScore && this.teacherDetailsScore.length > 0) {
    //     this.teacherDetailsScore.forEach((i) => {
    //       if (this.moduleDicOptions.find((m) => m.dicCode === i.module)) {
    //         i.moduleName = this.moduleDicOptions.find(
    //           (m) => m.dicCode === i.module
    //         ).dicName;
    //       }
    //     });
    //   }

    //   this.detailsLoading = false;
    // },
    findDic(cellValue) {
      if (this.rankList instanceof Array) {
        let find = this.rankList.find((f) => f.dicCode == cellValue);
        if (find) {
          return find.dicName;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    getDic(dicType) {
      return new Promise((resolve, reject) => {
        getData("/core/dic/getDictionaryList", {
          dicType,
        }).then((res) => {
          if (res.length > 0) {
            res = res.map((m) => {
              return {
                dicCode: m.dicCode,
                dicName: m.dicName,
              };
            });
            resolve(res);
          } else {
            reject();
          }
        });
      });
    },
    onTabClick(index, indexPath) {
      this.activeIndex = index;
      if (this.activeIndex == "first") {
        this.refreshTeachrInfo();
      } else {
        this.refresh();
      }
    },
    teacherStatistics() {
      this.loading = true;
      postJson("/teacherDevelopment/teacherStatistics", {
        academicTitles: this.teacherInfoForm.academicTitles
          ? this.teacherInfoForm.academicTitles.dicCode
          : null,
        keyword: this.teacherInfoForm.keyword,
        pageNum: this.teacherInfoForm.current,
        pageSize: this.teacherInfoForm.size,
        schoolCodes: this.teacherInfoForm.school
          ? [this.teacherInfoForm.school.schoolCode]
          : this.schoolCodes,
        userDuty: this.teacherInfoForm.userDuty
          ? this.teacherInfoForm.userDuty.dicCode
          : null,
      })
        .then((res) => {
          this.teacherStatisticsList = res.records;
          if (
            this.teacherStatisticsList &&
            this.teacherStatisticsList.length > 0
          ) {
            this.teacherStatisticsList.forEach((i) => {
              if (i.remark) {
                i.remarkInfo = JSON.parse(i.remark);
              } else {
                i.remarkInfo = "";
              }
            });
          } else {
            this.teacherStatisticsList = [];
          }

          this.teacherInfoForm.total = res.total;
        })
        .catch((e) => {
          console.log("e", e);
          this.teacherStatisticsList = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //分页模块一 教师信息
    firstHandleSizeChange(pageSize) {
      this.teacherInfoForm.current = 1;
      this.teacherInfoForm.size = pageSize;
      this.teacherStatistics();
    },
    firstTeacherPageChange(pageIndex) {
      this.teacherInfoForm.current = pageIndex;
      this.teacherStatistics();
    },
    //分页
    handleSizeChange(pageSize) {
      this.scoreSearch.current = 1;
      this.scoreSearch.size = pageSize;
      this.teacherScoreInfo();
    },
    teacherScorePageChange(pageIndex) {
      this.scoreSearch.current = pageIndex;
      this.teacherScoreInfo();
    },
    //获取教师积分
    teacherScoreInfo(current) {
      this.loading = false;
      current && (this.scoreSearch.current = current);
      postJson("/teacherDevelopment/getTeacherScoreInfoPage", {
        keyword: this.scoreSearch.keyword,
        pageNum: this.scoreSearch.current,
        pageSize: this.scoreSearch.size,
        schoolCodes: this.teacherAnalysisForm.school
          ? [this.teacherAnalysisForm.school.schoolCode]
          : this.schoolCodes,
        collegeCode:
          this.scoreSearch.collegeCode && this.scoreSearch.collegeCode.dicCode
            ? [this.scoreSearch.collegeCode.dicCode]
            : null,
        team: this.scoreSearch.team,
        schoolTerm: this.teacherAnalysisForm.schoolTerm,
        schoolYear: this.teacherAnalysisForm.schoolYear,
      })
        .then((res) => {
          this.loading = false;
          this.teacherScoreList = res.records;
          this.scoreSearch.total = res.total;
        })
        .catch((e) => {
          this.loading = false;
          this.teacherScoreList = [];
          this.scoreSearch.total = 0;
        });
    },
    //教师获奖统计
    teacherAwardInfo() {
      this.loading = true;
      postJson("/teacherDevelopment/teacherAwardInfo", {
        schoolCodes: this.teacherAnalysisForm.school
          ? [this.teacherAnalysisForm.school.schoolCode]
          : this.schoolCodes,
        schoolTerm: this.teacherAnalysisForm.schoolTerm,
        schoolYear: this.teacherAnalysisForm.schoolYear,
      })
        .then((res) => {
          this.loading = false;
          this.teacherAwardInfoList = res;
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    //教师职称统计
    teacherAcademicTitles() {
      this.loading = true;
      postJson("/teacherDevelopment/teacherAcademicTitles", {
        schoolCodes: this.teacherAnalysisForm.school
          ? [this.teacherAnalysisForm.school.schoolCode]
          : this.schoolCodes,
        schoolTerm: this.teacherAnalysisForm.schoolTerm,
        schoolYear: this.teacherAnalysisForm.schoolYear,
      })
        .then((res) => {
          this.loading = false;
          this.teacherAcademicTitlesList = res;
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    //教师年龄段统计
    teacherGeneration() {
      this.loading = true;
      postJson("/teacherDevelopment/teacherGeneration", {
        schoolCodes: this.teacherAnalysisForm.school
          ? [this.teacherAnalysisForm.school.schoolCode]
          : this.schoolCodes,
        schoolTerm: this.teacherAnalysisForm.schoolTerm,
        schoolYear: this.teacherAnalysisForm.schoolYear,
      })
        .then((res) => {
          this.loading = false;
          this.teacherGenerationList = res;
        })
        .catch((e) => {
          this.teacherGenerationList = [];
          this.loading = false;
        });
    },
    refreshTeachrInfo(pageIndex = 1) {
      this.teacherInfoForm.current = pageIndex;
      this.teacherStatistics();
    },

    refresh() {
      this.teacherAnalysisForm.current = 1;
      this.teacherGeneration();
      this.teacherAcademicTitles();
      this.teacherAwardInfo();
      this.teacherScoreInfo(1);
    },
    exportExcel(method) {
      // 判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去，避免导出的数据重复
      let fixRight = document
        .querySelector("#" + method)
        .querySelector(".el-table__fixed-right");
      let fixLeft = document
        .querySelector("#" + method)
        .querySelector(".el-table__fixed-left");
      let wb = null;
      let table = document.querySelector("#" + method);
      if (fixRight || fixLeft) {
        if (fixRight) {
          table = table.removeChild(fixRight);
        }
        if (fixLeft) {
          table = table.removeChild(fixLeft);
        }
        wb = XLSX.utils.table_to_book(table, { raw: true });
        if (fixRight) {
          document.querySelector("#" + method).appendChild(fixRight);
        }
        if (fixLeft) {
          document.querySelector("#" + method).appendChild(fixLeft);
        }
      } else {
        wb = XLSX.utils.table_to_book(table, { raw: true });
      }
      //获取二进制字符串作为输出
      let wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          "教师积分统计.xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
  },
};
</script>

<style lang="less">
.notab {
  .el-tabs__header {
    display: none;
  }
}
.photo {
  width: 60px;
  height: 60px;
}
.awardTit {
  text-align: center;
  font-size: 20px;
  font-weight: 540;
  color: #000;
}
.no-more {
  text-align: center;
  margin-top: 50px;
  font-weight: 540;
}
.filter-row,
.my-filter {
  align-items: center;
  .score {
    color: @color;
    vertical-align: middle;
    height: 32px;
    line-height: 32px;
    margin-right: 25px;
    font-size: 18px;
    min-width: 135px;
  }
  .se-nake {
    font-size: 15px;
    height: 32px;
    line-height: 32px;
  }
  .el-input-group__append {
    cursor: pointer;
    background: @color;
    color: #fff;
  }
}
</style>
